import request from '@/utils/request'

/**
 * 获取经销商用户首页待办事项
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerTodoList(data) {
  return request({
    url: 'api/getDealerTodoList',
    method: 'post',
    params: data
  })
}

/**
 * 经销商用户修改信息
 * @param data
 * @returns {AxiosPromise}
 */
export function editDealerUserInfo(data) {
  return request({
    url: 'api/editDealerUserInfo',
    method: 'post',
    params: data
  })
}

/**
 * 订单录入
 * @param data
 * @returns {AxiosPromise}
 */
export function OrderEntry(data) {
  return request({
    url: 'api/OrderEntry',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商订单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerOrderList(data) {
  return request({
    url: 'api/getDealerOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商尾款结清列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerBalanceList(data) {
  return request({
    url: 'api/getDealerBalanceList',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商整体订单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerALLOrderList(data) {
  return request({
    url: 'api/getDealerALLOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商订单详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerOrderDetail(data) {
  return request({
    url: 'api/getDealerOrderDetail',
    method: 'post',
    params: data
  })
}

/**
 * 删除订单
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteDealerOrder(data) {
  return request({
    url: 'api/deleteDealerOrder',
    method: 'post',
    params: data
  })
}

/**
 * 订单编辑提交
 * @param data
 * @returns {AxiosPromise}
 */
export function DealerOrderEdit(data) {
  return request({
    url: 'api/DealerOrderEdit',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商发货记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerDeliveryRecord(data) {
  return request({
    url: 'api/getDealerDeliveryRecord',
    method: 'post',
    params: data
  })
}

/**
 * 发货清单
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerDeliveryRecordDetail(data) {
  return request({
    url: 'api/getDealerDeliveryRecordDetail',
    method: 'post',
    params: data
  })
}
/**
 * 发货清单导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportDeliveryRecordDetail(data) {
  return request({
    url: 'api/exportDeliveryRecordDetail',
    method: 'post',
    params: data
  })
}
/**
 * 获取经销商用户权限
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerUserRole(data) {
  return request({
    url: 'api/getDealerUserRole',
    method: 'post',
    params: data
  })
}

/**
 * 修改经销商用户权限
 * @param data
 * @returns {AxiosPromise}
 */
export function editDealerUserRole(data) {
  return request({
    url: 'api/editDealerUserRole',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商编辑用户原有权限
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerEditUserRole(data) {
  return request({
    url: 'api/getDealerEditUserRole',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商账户详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerAccountData(data) {
  return request({
    url: 'api/getDealerAccountData',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商账户收支记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerAccountReceipt(data) {
  return request({
    url: 'api/getDealerAccountReceipt',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商样品预存款抵扣信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerJoinUse(data) {
  return request({
    url: 'api/getDealerJoinUse',
    method: 'post',
    params: data
  })
}

/**
 * 审核新注册经销商用户
 * @param data
 * @returns {AxiosPromise}
 */
export function checkRegisterDealerUser(data) {
  return request({
    url: 'api/checkRegisterDealerUser',
    method: 'post',
    params: data
  })
}

/**
 * 获取售后回访列表
 * @param data
 */
export function getDealerAfterVisit(data) {
  return request({
    url: 'api/getDealerAfterVisit',
    method: 'post',
    params: data
  })
}

/**
 * 售后回访评价操作
 * @param data
 */
export function dealerAfterVisitOper(data) {
  return request({
    url: 'api/dealerAfterVisitOper',
    method: 'post',
    params: data
  })
}

/**
 *获取经销商门店信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelShopInfo(data) {
  return request({
    url: 'api/getDelShopInfo',
    method: 'post',
    params: data
  })
}

/**
 * 修改经销商门店信息
 * @param data
 * @returns {AxiosPromise}
 */
export function updateDelShopInfo(data) {
  return request({
    url: 'api/updateDelShopInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商线下活动列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelOfflineList(data) {
  return request({
    url: 'api/getDelOfflineList',
    method: 'post',
    params: data
  })
}

/**
 * 添加/修改经销商线下活动
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelOffline(data) {
  return request({
    url: 'api/editDelOffline',
    method: 'post',
    params: data
  })
}

/**
 * 删除经销商线下活动
 * @param data
 * @returns {AxiosPromise}
 */
export function deltDelOffline(data) {
  return request({
    url: 'api/deltDelOffline',
    method: 'post',
    params: data
  })
}

/**
 * 根据id获取单个经销商线下活动详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelOfflineInfo(data) {
  return request({
    url: 'api/getDelOfflineInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商直播商品列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelLiveGoodsList(data) {
  return request({
    url: 'api/getDelLiveGoodsList',
    method: 'post',
    params: data
  })
}

/**
 * 添加/修改经销商直播间商品
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelLiveGoods(data) {
  return request({
    url: 'api/editDelLiveGoods',
    method: 'post',
    params: data
  })
}

/**
 * 删除经销商直播商品
 * @param data
 * @returns {AxiosPromise}
 */
export function delDelLiveGoods(data) {
  return request({
    url: 'api/delDelLiveGoods',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商直播列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelLiveList(data) {
  return request({
    url: 'api/getDelLiveList',
    method: 'post',
    params: data
  })
}

/**
 * 上传文件到微信服务器
 * @param data
 * @returns {AxiosPromise}
 */
export function uploadFileWx(data) {
  return request({
    url: 'api/uploadFileWx',
    method: 'post',
    params: data
  })
}

/**
 * 添加经销商直播
 * @param data
 * @returns {AxiosPromise}
 */
export function addDelLive(data) {
  return request({
    url: 'api/addDelLive',
    method: 'post',
    params: data
  })
}

/**
 * 删除经销商直播
 * @param data
 * @returns {AxiosPromise}
 */
export function delDelLive(data) {
  return request({
    url: 'api/delDelLive',
    method: 'post',
    params: data
  })
}

/**
 * 根据id获取单个经销商直播活动详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelLiveInfo(data) {
  return request({
    url: 'api/getDelLiveInfo',
    method: 'post',
    params: data
  })
}

/**
 * 经销商选择商品添加
 * @param data
 * @returns {AxiosPromise}
 */
export function addDelLiveItemGoods(data) {
  return request({
    url: 'api/addDelLiveItemGoods',
    method: 'post',
    params: data
  })
}

/**
 * 经销商直播间选择的商品列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelLiveItemGoodsList(data) {
  return request({
    url: 'api/getDelLiveItemGoodsList',
    method: 'post',
    params: data
  })
}

/**
 * 经销商小程序首页banner列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelShopBannerList(data) {
  return request({
    url: 'api/getDelShopBannerList',
    method: 'post',
    params: data
  })
}

/**
 * 添加/修改经销商小程序首页banner
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelShopBanner(data) {
  return request({
    url: 'api/editDelShopBanner',
    method: 'post',
    params: data
  })
}

/**
 * 删除经销商小程序首页banner
 * @param data
 * @returns {AxiosPromise}
 */
export function delDelShopBanner(data) {
  return request({
    url: 'api/delDelShopBanner',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商端预约信息列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelReservationList(data) {
  return request({
    url: 'api/getDelReservationList',
    method: 'post',
    params: data
  })
}

/**
 * 处理经销商端预约信息
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelReservation(data) {
  return request({
    url: 'api/editDelReservation',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商投诉意见列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelComplaintsList(data) {
  return request({
    url: 'api/getDelComplaintsList',
    method: 'post',
    params: data
  })
}

/**
 * 处理经销商投诉意见
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelComplaints(data) {
  return request({
    url: 'api/editDelComplaints',
    method: 'post',
    params: data
  })
}

/**
 * 获取单个经销商投诉意见详情中图片列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelComplaintsImgList(data) {
  return request({
    url: 'api/getDelComplaintsImgList',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的客户分组列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelClientGroupList(data) {
  return request({
    url: 'api/getDelClientGroupList',
    method: 'post',
    params: data
  })
}

/**
 * 编辑经销商的客户分组
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelClientGroup(data) {
  return request({
    url: 'api/editDelClientGroup',
    method: 'post',
    params: data
  })
}

/**
 * 删除经销商的客户分组
 * @param data
 * @returns {AxiosPromise}
 */
export function delDelClientGroup(data) {
  return request({
    url: 'api/delDelClientGroup',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的客户标签列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelClientTagList(data) {
  return request({
    url: 'api/getDelClientTagList',
    method: 'post',
    params: data
  })
}

/**
 * 编辑经销商的客户标签
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelClientTag(data) {
  return request({
    url: 'api/editDelClientTag',
    method: 'post',
    params: data
  })
}

/**
 * 编辑经销商的客户标签
 * @param data
 * @returns {AxiosPromise}
 */
export function delDelClientTag(data) {
  return request({
    url: 'api/delDelClientTag',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的客户列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelClientList(data) {
  return request({
    url: 'api/getDelClientList',
    method: 'post',
    params: data
  })
}

/**
 * 修改经销商的客户信息
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelClientInfo(data) {
  return request({
    url: 'api/editDelClientInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的客户详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelClientInfo(data) {
  return request({
    url: 'api/getDelClientInfo',
    method: 'post',
    params: data
  })
}

/**
 * 编辑经销商的客户跟进记录
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelClientFollow(data) {
  return request({
    url: 'api/editDelClientFollow',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的客户跟进记录列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelClientFollowList(data) {
  return request({
    url: 'api/getDelClientFollowList',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的客户晒家浏览记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelClientShowHomeBrowse(data) {
  return request({
    url: 'api/getDelClientShowHomeBrowse',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的客户案例浏览记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelClientCaseBrowse(data) {
  return request({
    url: 'api/getDelClientCaseBrowse',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的客户装修攻略浏览记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelClientStrategyBrowse(data) {
  return request({
    url: 'api/getDelClientStrategyBrowse',
    method: 'post',
    params: data
  })
}

/**
 *获取绑定微信第三方预授权码
 * @param data
 * @returns {AxiosPromise}
 */
export function getWxPreAuthCode(data) {
  return request({
    url: 'api/getWxPreAuthCode',
    method: 'post',
    params: data
  })
}

/**
 *获取小程序授权信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getWxAuthorizerInfo(data) {
  return request({
    url: 'api/getWxAuthorizerInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商职位列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerPositionList() {
  return request({
    url: 'api/getDealerPositionList',
    method: 'post'
  })
}

/**
 * 获取经销商访客列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelVisitorList(data) {
  return request({
    url: 'api/getDelVisitorList',
    method: 'post',
    params: data
  })
}

/**
 * 获取C端用户浏览记录列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getBrowsinghistoryList(data) {
  return request({
    url: 'api/getBrowsinghistoryList',
    method: 'post',
    params: data
  })
}

/**
 * 获取装修阶段字典
 */
export function getStageDictionary() {
  return request({
    url: 'api/getStageDictionary',
    method: 'post'
  })
}

/**
 * 合同签订(经销商用户)
 * @param data
 * @returns {AxiosPromise}
 */
export function signDealerClientContract(data) {
  return request({
    url: 'api/signDealerClientContract',
    method: 'post',
    params: data
  })
}

/**
 * 客户交换跟进
 * @param data
 * @returns {AxiosPromise}
 */
export function exchangeFollowClient(data) {
  return request({
    url: 'api/exchangeFollowClient',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商的项目列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelDecorationList(data) {
  return request({
    url: 'api/getDelDecorationList',
    method: 'post',
    params: data
  })
}

/**
 * 获取项目装修阶段
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelDecorationStageList(data) {
  return request({
    url: 'api/getDelDecorationStageList',
    method: 'post',
    params: data
  })
}

/**
 * 提交项目排期
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditDecorationStage(data) {
  return request({
    url: 'api/addOrEditDecorationStage',
    method: 'post',
    params: data
  })
}

/**
 * 获取项目详细信息及跟进记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getDelDecorationDetail(data) {
  return request({
    url: 'api/getDelDecorationDetail',
    method: 'post',
    params: data
  })
}

/**
 * 添加项目跟进
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditDecorationFollow(data) {
  return request({
    url: 'api/addOrEditDecorationFollow',
    method: 'post',
    params: data
  })
}

/**
 * 编辑项目信息
 * @param data
 * @returns {AxiosPromise}
 */
export function editDelDecorationInfo(data) {
  return request({
    url: 'api/editDelDecorationInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商客户合同列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerClientSignList(data) {
  return request({
    url: 'api/getDealerClientSignList',
    method: 'post',
    params: data
  })
}

/**
 * 代注册小程序申请提交
 * @param data
 * @returns {AxiosPromise}
 */
export function subEditDealerRegwxApply(data) {
  return request({
    url: 'api/subEditDealerRegwxApply',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商代注册审核结果
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerRegwxApplyDetail(data) {
  return request({
    url: 'api/getDealerRegwxApplyDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商代注册列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerRegwxApplyList(data) {
  return request({
    url: 'api/getDealerRegwxApplyList',
    method: 'post',
    params: data
  })
}
